export default "__VITE_ASSET__C$ze4L3Z__"